
import Vue from 'vue'
import {eventBus} from './services/event-bus'

export default Vue.extend({
        name: 'App',

        data() {
            return {
                hasErrorOccured: false,
                errorMessage: ''
            }
        },

        errorCaptured(error): void {
            eventBus.$emit('error', error.message);
        },

        mounted(): void {
            window.onerror = this.onWindowError;
            Vue.config.errorHandler = this.onVueError;
            eventBus.$on('error', this.handleError);
        },

        methods: {
            handleError: function (message: string) {
                // eslint-disable-next-line no-console
                console.log(message);
                if(message && message.indexOf('code 401') > -1) {
                    const office =  JSON.parse(String(localStorage.getItem('user'))).office;
                    this.$store.dispatch('auth/logout');
                    this.$router.push(`/${office}/pages/login`);
                }
                this.errorMessage = message;
                this.hasErrorOccured = true;
            },
            onWindowError(message: any): void {
                this.handleError(message);
            },
            onVueError({message}: any): void {
                this.handleError(message);
            }
        }
    });
